module.exports = __webpack_public_path__ + "1fe431b7d7e2c60ffe77a2bbb3ff30e0.svg";